import { VideoGAActions, trackEvent } from 'shared/util/video-ga-events'

class VideoPlayerAnalytics {
    videoId: number | string
    category?: string
    constructor(videoId: number | string, category?: string) {
        this.videoId = videoId
        this.category = category
    }
    trackAction = (action: VideoGAActions) => {
        trackEvent(action, this.videoId, this.category)
    }
    onPlay = () => {
        this.trackAction('start')
    }
    onPause = () => {
        this.trackAction('pause')
    }
    onEnded = () => {
        this.trackAction('complete')
    }
    onMute = (isMuted: boolean) => {
        this.trackAction(isMuted ? 'mute' : 'unmute')
    }
    onFullscreen = (isFullscreen: boolean) => {
        this.trackAction(isFullscreen ? 'playerExpand' : 'playerCollapse')
    }
    onShare = (isOpen: boolean) => {
        this.trackAction(isOpen ? 'Share Sheet On' : 'Share Sheet Off')
    }
    onShareAction = shareType => {
        this.trackAction(shareType)
    }
    onQuartile = (quartile: 0.25 | 0.5 | 0.75) => {
        switch (quartile) {
            case 0.25:
                this.trackAction('firstQuartile')
                break
            case 0.5:
                this.trackAction('midpoint')
                break
            case 0.75:
                this.trackAction('thirdQuartile')
                break
        }
    }
}

export default VideoPlayerAnalytics
